<script>
import Boeken from '~/pages/boeken/index'
export default Boeken
</script>
